import { env as dynamicPublicEnv } from '$env/dynamic/public';
import { PUBLIC_API_BASE_URI } from '$env/static/public';

export const API_BASE_URI =
    dynamicPublicEnv.PUBLIC_API_BASE_URI ?? PUBLIC_API_BASE_URI ?? 'https://api.iflirt.dev';
